import React, {useState, useEffect} from 'react';
import axios from 'axios';
import '../css/JobApplicants.css';
const JobApplicants = () => {

    const [groupedApplications, setGroupedApplications] = useState({});
      const [loading, setLoading] = useState(true);
      
     
      useEffect(() => {
    const fetchApplicants = async () => {
      try {
        const res = await axios.get('/api/jobapplicants');
        const apps = res.data;

        // Group by program name
        const grouped = {};
        apps.forEach((app) => {
          const jobName = app.jobId?.position || "Unknown Job";
          console.log('job name', jobName);
          if (!grouped[jobName]) {
            grouped[jobName] = [];
          }
          grouped[jobName].push(app);
        });

        setGroupedApplications(grouped);
      } catch (err) {
        console.error("Failed to fetch applications:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchApplicants();
  }, []);


 

  const handleToggleStatus = async (appId, newStatus) => {
  console.log('entered toggle');
  try {
    const res = await axios.put(
      `/api/applications/${appId}/status`,
      { status: newStatus }
    );

    const updatedStatus = res.data.status;

    setGroupedApplications(prev => {
      const updatedGroups = {};

      for (const jobId in prev) {
        updatedGroups[jobId] = prev[jobId].map(app =>
          app._id === appId ? { ...app, status: updatedStatus } : app
        );
      }

      return updatedGroups;
    });
  } catch (error) {
    console.error('Status toggle error:', error.response?.data?.message || error.message);
    alert('Failed to update application status');
  }
};

const handleDocumentClick = async (document) => {
  try {
    if (!document?.url) {
      alert("Document URL not available");
      return;
    }

    // ✅ CASE 1: Cloudinary (public URLs)
    if (document.url.includes("cloudinary.com")) {
      window.open(document.docUrl, "_blank");
      return;
    }

    // ✅ CASE 2: S3 (private, needs signing)
    if (document.url.includes("amazonaws.com")) {
      const res = await fetch(
        `/api/s3/view-url?fileUrl=${encodeURIComponent(document.url)}`
      );

      if (!res.ok) {
        throw new Error("Failed to get signed URL");
      }

      const { url: signedurl } = await res.json();
      window.open(signedurl, "_blank");
      return;
    }

    // ❌ Unknown source
    console.error("Unknown document source:", document.url);
    alert("Unsupported document source");

  } catch (err) {
    console.error("Error opening document:", err);
    alert("Unable to open document");
  }
};
//   const handleDocumentClick = (document) => {
//     console.log('entered doc click');
//   if (document?.url) {
//     window.open(document.url, '_blank', 'noopener,noreferrer');
//   } else {
//     console.error('Document URL not found:', document);
//     alert('Document URL not available');
//   }
// };

  if (loading) {
    return (
      <div className="ja-loader-wrapper">
        <div className="ja-spinner" />
      </div>
    );
  }

    const hasJobs = Object.keys(groupedApplications).length > 0;


    return (
    <div className="ja-page-wrapper">
      <div className="ja-header-row">
        <div>
          <h2 className="ja-page-title">Job Applicants</h2>
          <p className="ja-page-subtitle">
            Review all candidates grouped by open positions.
          </p>
        </div>
      </div>

      {!hasJobs ? (
        <div className="ja-empty-state">
          <h4 className="ja-empty-title">No applicants yet</h4>
          <p className="ja-empty-text">
            Once candidates apply for openings, their profiles will appear here.
          </p>
        </div>
      ) : (
        <div className="ja-job-grid">
          {Object.entries(groupedApplications).map(([jobName, apps]) => (
            <div key={jobName} className="ja-job-card">
              <div className="ja-job-header">
                <h3 className="ja-job-title">{jobName}</h3>
                <span className="ja-job-count">
                  {apps.length} applicant{apps.length !== 1 ? 's' : ''}
                </span>
              </div>

              <div className="ja-applications-wrapper">
                {apps.map((app) => (
                  <div key={app._id} className="ja-application-card">
                    <div className="ja-application-main">
                      <div className="ja-applicant-heading">
                        <p className="ja-applicant-name">{app.name}</p>
                        <p className="ja-applicant-email">{app.email}</p>
                      </div>

                      <div className="ja-application-details">
                        <p className="ja-detail-line">
                          <span className="ja-detail-label">Contact:</span>
                          {app.phone}
                        </p>
                        <p className="ja-detail-line">
                          <span className="ja-detail-label">Education:</span>
                          {app.education}
                        </p>
                        <p className="ja-detail-line">
                          <span className="ja-detail-label">Experience:</span>
                          {app.experience}
                        </p>
                        <p className="ja-detail-line">
                          <span className="ja-detail-label">Location:</span>
                          {app.district}, {app.state}
                        </p>
                        <p className="ja-detail-line">
                          <span className="ja-detail-label">Resume:</span>
                          <span
                            className="ja-resume-link"
                            onClick={() => handleDocumentClick(app.resume)}
                          >
                            {app.resume?.docname || 'View document'}
                          </span>
                        </p>
                      </div>
                    </div>

                    <div className="ja-status-controls">
                      <span
                        className={
                          app.status === 'Selected'
                            ? 'ja-status-badge ja-status-selected'
                            : 'ja-status-badge ja-status-rejected'
                        }
                      >
                        {app.status === 'Selected' ? 'Selected' : 'Rejected'}
                      </span>

                      <button
                        className={
                          app.status === 'Selected'
                            ? 'ja-toggle-btn ja-toggle-to-rejected'
                            : 'ja-toggle-btn ja-toggle-to-selected'
                        }
                        onClick={() =>
                          handleToggleStatus(
                            app._id,
                            app.status === 'Selected' ? 'Rejected' : 'Selected'
                          )
                        }
                      >
                        Set {app.status === 'Selected' ? 'Rejected' : 'Selected'}
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
//     return (
//         <div>
//          {Object.entries(groupedApplications).map(([jobName, apps]) => (
//               <div key={jobName} className='jobCard'>
//                 <div className='jobInfo'>
//                   <h3> Job Name: {jobName}</h3>
//         <div className='contentCard'>
           
//             {apps.map((app) => (
//               <div key={app._id} className='applicationCard'>
//                 <div className='applicationInfo'>
//                   <h4 className='applicationName'><strong>Applicant Name:</strong> {app.name}</h4>
//                   <p className='applicationPosition'><strong>Email:</strong> {app.email}</p>
//                   <p className='applicationPosition'><strong>Contact Number:</strong> {app.phone}</p>
//                    <p className='applicationPosition'><strong>Education:</strong> {app.education}</p>
//                  <p className='applicationPosition'><strong>Experience:</strong> {app.experience}</p>
//                  <p className='applicationPosition'><strong>State:</strong> {app.state}</p>
//                  <p className='applicationPosition'><strong>District:</strong> {app.district}</p>
                  
//                   <p className='applicationPosition'><strong>Resume:</strong> {" "}
//                      <span
//                      style={{ color: "blue", textDecoration: "underline", cursor: "pointer" }}
//                       onClick={() => handleDocumentClick(app.resume)}
//                      >
//                         {app.resume?.docname}
//                      </span>
//                   </p>

//                 </div>

//                  <div className='statusControls'>
//   <span
//     style={{
     
//       backgroundColor: app.status === 'Selected' ? '#dcfce7' : '#fef2f2',
//       color: app.status === 'Selected' ? '#065f46' : '#991b1b',
      
//     }}
//     className='statusBadge'
//   >
//     {app.status === 'Selected' ? 'Selected' : 'Rejected'}
//   </span>

//   <button
//     style={{
      
//       backgroundColor: app.status === 'Selected' ? '#fef2f2' : '#dcfce7',
//       color: app.status === 'Selected' ? '#991b1b' : '#065f46',
//       border: '1px solid',
//       borderColor: app.status === 'Selected' ? '#fca5a5' : '#86efac',
//     }}
//     className='toggleButton'
//     onClick={() =>
//       handleToggleStatus(app._id, app.status === 'Selected' ? 'Rejected' : 'Selected')
//     }
//   >
//     Set {app.status === 'Selected' ? 'Rejected' : 'Selected'}
//   </button>
// </div>
              
//               </div>
//             ))}
//           </div>
//           </div>
//         </div>
//          ))}
//          </div>
//     );
}



export default JobApplicants;

